export const METRIC_GRAINS = Object.freeze({
  EMPLOYEES: "employees",
  COVERED_PEOPLE: "covered people",
  HOUSEHOLDS: "households",
});

export const PROGRAM_METRIC_GRAIN_BY_FIELD = Object.freeze({
  eligibleCount: METRIC_GRAINS.EMPLOYEES,
  enrolledCount: METRIC_GRAINS.EMPLOYEES,
  notEnrolledCount: METRIC_GRAINS.EMPLOYEES,
  opportunityCount: METRIC_GRAINS.EMPLOYEES,
  opportunitiesOnEnrolledCount: METRIC_GRAINS.EMPLOYEES,
  opportunitiesOnNotEnrolledCount: METRIC_GRAINS.EMPLOYEES,
  suppressedCount: METRIC_GRAINS.EMPLOYEES,
  highPriorityCount: METRIC_GRAINS.EMPLOYEES,
  mediumPriorityCount: METRIC_GRAINS.EMPLOYEES,
  lowPriorityCount: METRIC_GRAINS.EMPLOYEES,
  eligibleWithDependentsCount: METRIC_GRAINS.COVERED_PEOPLE,
  enrolledWithDependentsCount: METRIC_GRAINS.COVERED_PEOPLE,
  notEnrolledWithDependentsCount: METRIC_GRAINS.COVERED_PEOPLE,
  opportunitiesOnEnrolledWithDependentsCount: METRIC_GRAINS.COVERED_PEOPLE,
  opportunitiesOnNotEnrolledWithDependentsCount: METRIC_GRAINS.COVERED_PEOPLE,
});

export function programMetric(program, field) {
  const grain = PROGRAM_METRIC_GRAIN_BY_FIELD[field];
  if (!grain) throw new Error(`No metric-grain contract exists for program field: ${field}`);
  return { value: program?.[field] ?? null, grain };
}

export function householdMetricUnavailable(reason = "No household-level metric is supplied by this API") {
  return { value: null, grain: METRIC_GRAINS.HOUSEHOLDS, unavailableReason: reason };
}
